/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DaypartsDaypartIdMenusMenuIdItemsItemIdDelete$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;

/**
 * Menu ID
 */
  menuId: string;

/**
 * Item (regular and category) ID
 */
  itemId: string;
}

export function daypartsDaypartIdMenusMenuIdItemsItemIdDelete(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdMenusMenuIdItemsItemIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdMenusMenuIdItemsItemIdDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('menuId', params.menuId, {});
    rb.path('itemId', params.itemId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

daypartsDaypartIdMenusMenuIdItemsItemIdDelete.PATH = '/dayparts/{daypartId}/menus/{menuId}/items/{itemId}';
